import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import anime from 'animejs';

import { Link } from '../Link';

class Component extends React.PureComponent {
  static displayName = 'SocialLinks';

  static propTypes = {
    theme: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    energy: PropTypes.object.isRequired,
    audio: PropTypes.object.isRequired,
    sounds: PropTypes.object.isRequired,
    className: PropTypes.any,
    itemClassName: PropTypes.string,
    animateY: PropTypes.bool,
    onEnter: PropTypes.func,
    onExit: PropTypes.func,
    onLinkStart: PropTypes.func,
    onLinkEnd: PropTypes.func
  };

  static defaultProps = {
    animateY: true
  };

  enter () {
    const { energy, sounds, animateY, onEnter } = this.props;
    const { duration } = energy;

    sounds.fade.play();

    anime({
      targets: this.element,
      easing: 'easeOutCubic',
      keyframes: [
        { opacity: 1, duration: duration.enter / 3 },
        { opacity: 0, duration: duration.enter / 5 },
        { opacity: 1, duration: duration.enter / 2 }
      ],
      complete: () => onEnter && onEnter()
    });

    if (animateY) {
      anime({
        targets: this.element,
        easing: 'easeOutCubic',
        translateY: [-10, 0],
        duration: duration.enter
      });
    }
  }

  exit () {
    const { energy, sounds, onExit } = this.props;
    const { duration } = energy;

    sounds.fade.play();

    anime({
      targets: this.element,
      easing: 'easeOutCubic',
      keyframes: [
        { opacity: 0, duration: duration.exit / 3 },
        { opacity: 1, duration: duration.exit / 5 },
        { opacity: 0, duration: duration.exit / 2 }
      ],
      complete: () => onExit && onExit()
    });
  }

  render () {
    const {
      theme,
      classes,
      energy,
      audio,
      sounds,
      className,
      itemClassName,
      animateY,
      onEnter,
      onExit,
      onLinkStart,
      onLinkEnd,
      ...etc
    } = this.props;

    const A = elprops => (
      <Link
        className={cx(classes.item, itemClassName)}
        onLinkStart={onLinkStart}
        onLinkEnd={onLinkEnd}
        onMouseEnter={() => sounds.hover.play()}
        {...elprops}
      />
    );

    return (
      <div
        className={cx(classes.root, className)}
        ref={ref => (this.element = ref)}
        {...etc}
      >
		<A href='https://github.com/dawndrums' title='GitHub' target='_blank'>
		  <span className='mdi mdi-github-circle' />
		</A>
        <A href='https://mastodon.social/@dawndrums' title='Mastodon' target='mastodon'>
          <span className='mdi mdi-mastodon' />
        </A>				
        <A href='https://youtube.com/@dawndrums-o7m' title='Youtube' target='youtube'>
          <span className='mdi mdi-youtube-tv' />
        </A>	
        <A href='https://discord.gg/HVb5jNBTRH' title='Discord' target='discord'>
          <span className='mdi mdi-discord' />
        </A>		
        <A href='https://matrix.to/#/#dawndrums-r2:matrix.org' title='Matrix.org' target='matrix.org'>
          <span className='mdi mdi-matrix' />
        </A>
        <A href='https://docs.dawndrums.tn' title='Documentation base' target='documentation'>
          <span className='mdi mdi-file-document-outline' />
        </A>		
        <A href='https://forum.dawndrums.tn' title='Forum' target='forum'>
          <span className='mdi mdi-forum' />
        </A>		
        <A href='mailto:contact@dawndrums.tn' title='Email' target='email'>
          <span className='mdi mdi-email-outline' />
        </A>		
      </div>
    );
  }
}

export { Component };
